import { stat } from "fs";

// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request(state) {
    state.authStatus = "loading";
  },
  auth_success(
    state,
    { token, user, role, usermenu, settings, datetype, inboxcount, company }
  ) {
    state.authStatus = "success";
    state.token = token;
    state.user = user;
    state.role = role;
    state.usermenu = usermenu;
    state.settings = settings;
    state.inboxcount = inboxcount;
    state.company = company;
    state.datetype = datetype;
  },
  set_inbox_count(state, { inboxcount }) {
    state.inboxcount = inboxcount;
  },
  auth_error(state) {
    state.authStatus = "error";
  },
  logout(state) {
    state.authStatus = "";
    state.token = "";
    state.usermenu = null;
    state.settings = null;
    state.datetype = null;
    state.inboxcount = null;
    state.company = null;
    state.user=null;
  },
  setPageTitle(state, title) {
    state.pagetitle = title;
  },
  setTableList(state, tableList) {
    state.tableList = tableList;
  },
  setSnackbar(state, snackbar) {
    state.snackbar = snackbar;
  },
  setDateType(state, datetype) {
    state.datetype = datetype;
  },
  setMessage(state,message){
    state.message = message;
  }
};
